import React from 'react'
import { observer } from 'mobx-react-lite'
import { Table } from 'antd'
import { OrderStore } from '../store'
import { columns } from './columns'

export const OrderListFeature = observer(() => (
  <Table dataSource={OrderStore.ordersSliced} columns={columns} />
))
